import type { IconData } from '@stacksjs/iconify-core'

export const healthDrugMedicineBagAid2: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 6.855H32v13.72h-1.52ZM28.96 22.1H3.05v-1.52H1.53v9.14h1.52v-6.1H6.1v6.1H3.05v1.52h25.91v-1.52h-3.05v-6.1h3.05v6.1h1.52v-9.14h-1.52Zm-7.62 7.62H10.67v-6.1h10.67Zm7.62-24.385h1.52v1.52h-1.52Zm-9.15 10.67v1.52h1.53v3.05h4.57v-3.05h1.52v-1.52Zm4.58 3.04h-1.53v-1.52h1.53Zm-3.05-9.14h-3.05v-3.05h-4.57v3.05h-3.05v4.57h3.05v3.05h4.57v-3.05h3.05zM9.15.765h13.71v1.52H9.15Z\"/><path fill=\"currentColor\" d=\"M4.58 16.005v1.52H6.1v3.05h4.57v-3.05h1.53v-1.52Zm4.57 3.04H7.62v-1.52h1.53Zm19.81-13.71v-1.53h-4.57v-1.52h-1.53v1.52H9.15v-1.52H7.62v1.52H3.05v1.53zm-27.43 0h1.52v1.52H1.53ZM0 6.855h1.53v13.72H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default healthDrugMedicineBagAid2
